import CreateAttributeList, { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { AttributeDefinition, AttributeInputType, sharedComponentAttributes } from "../Data/WBData";
import WebDesigner from "../WebDesigner";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";

export default class BusinessMemberships extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessMemberships;
        this.displayName = "Memberships";
        this.dropList = defaultDropList;
        this.editList = [  ]; // possibly delete because its a dup
        this.resizeType = ResizeableType.All;
        this.vagaroLink = "https://www.vagaro.com/merchants/settings/thingswesell/membership";

        this.primaryEditAttributes = [
            componentAttributeTypes.multiLocation, 
            componentAttributeTypes.layoutId, 
            componentAttributeTypes.membershipFilter, 
            "panelRadius", 
            "panelPadding",
            "panelLayoutPadding"


        ];
        this.colorFields = ["serviceTitleColor","detailColor","descColor","panelColor","panelBorder","color","backgroundColor"];
        this.editList = [...this.colorFields, componentAttributeTypes.membershipFilter, ...this.primaryEditAttributes, componentAttributeTypes.multiLocation, componentAttributeTypes.alloWMultiLocalationBooking, componentAttributeTypes.layoutId,  ...CreateAttributeList(true, true, true, true, false, false,false)];
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor"><path d="M256 0c-17.7 0-32 14.3-32 32V96c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H256zM192 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H384v48H512c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H192V64zm96 240a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z" /></svg>
        this.cssDefinitions =[
            new NodeCSSClassDefinition(".service-panel",
            [
                {key:"panelColor",cssProperty:"background",default:""},
                {key:"panelRadius",cssProperty:"border-radius",default:""},
                {key:"panelPadding",cssProperty:"padding",default:""},
                {key:"panelBorder",cssProperty:"border-color",default:""}
        
             ]),
             new NodeCSSClassDefinition(".b-panel-container",
             [
                 {key:"panelLayoutPadding",cssProperty:"padding",default:""},
                 
              ]),
             new NodeCSSClassDefinition(".service-title",
             [
                 {key:"serviceTitleColor",cssProperty:"color",default:"",stencil:"transparent"},
        
                 
              ]),
              new NodeCSSClassDefinition(".service-description",
              [
                  {key:"descColor",cssProperty:"color",default:"",stencil:"transparent"},
         
                  
               ]),
               new NodeCSSClassDefinition(".service-pricing",
               [
                   {key:"detailColor",cssProperty:"color",default:"",stencil:"transparent"},
          
                   
                ]),
                new NodeCSSClassDefinition(".s-other:not(.promo-container) ",
                [
                    {key:"detailColor",cssProperty:"color",default:"",stencil:"transparent"},
           
                    
                 ]),
        ];
    }



    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        console.log('onFirstTimeCreation thisLayout', thisLayout);
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }


    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            sharedComponentAttributes.contentSpacing,
            sharedComponentAttributes.panelRadius,
            sharedComponentAttributes.panelSpacing,
            new AttributeDefinition(componentAttributeTypes.layoutId, "Layout", componentAttributeTypes.layoutId, AttributeInputType.SelectField, [
                { label: "Default", value: "1" },
                { label: "Horizontal", value: "2" },
                { label: "Cards", value: "3" },
            ]),
            new AttributeDefinition("panelColor", "Panel Background", "", AttributeInputType.ColorField),
       
            new AttributeDefinition(componentAttributeTypes.membershipFilter, "Filters", "", AttributeInputType.MembershipSelector),
        ]
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);
        const atts = GetNodeDomAttributes(" max-w-100  clamp-height resizable-container w-full nice-scroll scrollable vb-control" , component, screenSize, isEditor);
        const layout = getNodeComponentAttributeValue(component, componentAttributeTypes.layoutId, "1");
        const filters = getNodeComponentAttributeValue(component, componentAttributeTypes.membershipFilter, "")

        if (!isEditor) {
            return <BusinessPlaceHolder node={component} inFilter={filters} dataKey="memberships" layout={layout} classNames={atts.className} />
        }

        return (
            <>
                <style>
                    {super.GetComponentGlobalCSS(component, isEditor)}
                </style>
                <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
                    <GenericBusinessControl key={component.id + bid} filters={filters} bLocationId={bid} layout={layout} dataKey="memberships" node={component} userContext={siteData} />
                </div>
            </>
        )
    }
}


